import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M31.967 18H.029a38 38 0 0 1-.026-2.017c-.008-.64.001-1.304.03-1.983h31.938q.04 1.034.026 2.016.013.964-.03 1.984",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m6.667 26.382-.837 1.951.026-2.125-1.554 1.441.883-1.93-2.002.68 1.588-1.402-2.104-.197 2.017-.632-1.843-1.04 2.1.247-1.263-1.704 1.817 1.085-.464-2.073 1.221 1.734.415-2.084.414 2.084 1.221-1.734-.464 2.073 1.817-1.085-1.262 1.704 2.099-.247-1.843 1.04 2.018.632-2.105.197L10.15 26.4l-2.002-.681.883 1.93-1.554-1.44.026 2.124z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagNru = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagNru_default = SvgFlagNru;

export { FlagNru_default as default };
